import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmActionForm from '../../../components/forms/FirearmActionForm';
import { useCreateFirearmAction } from '../../../hooks/useFirearmActionApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmActionDTO } from '../../../services/apiClient';

const FirearmActionCreate: React.FC = () => {
  const createFirearmAction = useCreateFirearmAction();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Actions', href: '/admin/firearmactions' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmActionDTO) => {
    try {
      await createFirearmAction.mutateAsync(data);
      navigate('/admin/firearmactions');
    } catch (error) {
      console.error('Error creating FirearmAction:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmactions"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmAction.Edit'
    >
        <FirearmActionForm
          initialValues={{} as FirearmActionDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmactions')}
        />
    </AdminLayout>
  );
};

export default FirearmActionCreate;